import Slider from "./slider";

export default function(el) {
    const heroSliderEl = el.querySelector(".rh__slider--hero");
    const logosSliderEl = el.querySelector(".rh__slider--logos");

    if (!heroSliderEl || !logosSliderEl) return;

    const heroSider = Slider(heroSliderEl);
    const logosSlider = Slider(logosSliderEl);

    logosSlider.events.on("indexChanged", (sliderInfo) => {
        heroSider.goTo(sliderInfo.displayIndex - 1);
    });
}
